import {
  ContentItemView,
  ContentModel,
  ContentText,
  isContentModel,
  isContentText,
} from '@gkn-ili/views/dist/PageContent';
import { View3DCameraState } from '../../../context/context3D';

function convertViewState(state: View3DCameraState): {
  position: [number, number, number];
  rotation: [number, number, number];
  target: [number, number, number];
} {
  return {
    position: [state.position.x, state.position.y, state.position.z],
    rotation: [state.rotation.x, state.rotation.y, state.rotation.z],
    target: [state.target.x, state.target.y, state.target.z],
  };
}
export type AppEdit3DContentFormFields = { model: { model: ContentModel['content']['model']; saveViewState: boolean } };

export type AppEditContentFormFields = {
  contentType: 'text' | 'model';
  text: ContentText['content'];
} & AppEdit3DContentFormFields;

export function AppEditContentGetDefaultValues(page: ContentItemView): AppEditContentFormFields {
  return {
    contentType: isContentModel(page) ? 'model' : 'text',
    text: isContentText(page) ? page.content : { text: [] },
    model: isContentModel(page)
      ? { ...page.content, saveViewState: true }
      : {
          model: {
            configuration: {
              enhancedViewKey: '',
              modifiers: [],
            },
          },
          saveViewState: true,
        },
  };
}
export function AppEditContentGetSaveData(
  data: AppEditContentFormFields,
  initial: ContentItemView,
  cameraView: View3DCameraState | undefined,
): ContentItemView['content'] {
  const content =
    data.contentType === 'text'
      ? data.text
      : {
          model: data.model.model,
          view:
            data.model.saveViewState && cameraView
              ? convertViewState(cameraView)
              : isContentModel(initial)
                ? initial.content.view
                : undefined,
        };
  return content;
}
